var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-center login-footer-text pt-0",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(_vm.getDate())+"   Smart Energy Lab. "),_c('br'),_vm._v(" Todos os Direitos Reservados. ")])}
var staticRenderFns = []

export { render, staticRenderFns }